import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

/* Testimonial-Frage (Coach-Cockpit W1.7): die Frage, drei Auswahlknöpfe und der ausführliche Einwilligungstext.
   Wiederverwendbar — Kundenakte (TestimonialKarte) jetzt, später am Ende des Ergebnis-Check-ups im Stepper.
   Rein darstellend: Daten und Speichern kommen vom Aufrufer.

   Props:
     aktiv    – Schalter (false = gesperrt: Knöpfe aus, Hinweis „Entwurf, noch nicht freigegeben“)
     text     – {kurzfrage, titel, text, version, entwurf, umfaenge:[{wert, text}]} (Server: `einwilligung_text`)
     stand    – {umfang, status, erteilt} (Server: `einwilligung`) oder null
     onWahl   – async (umfang, version) => … ; Fehler zeigt der Aufrufer
     testId   – data-testid */

export default function TestimonialFrage({ aktiv, text, stand, onWahl, testId = 'testimonial-frage' }) {
  const [laeuft, setLaeuft] = useState(null);
  const [lang, setLang] = useState(false);
  if (!text) return null;
  const gewaehlt = stand?.status === 'aktiv' || stand?.status === 'abgelehnt' ? stand.umfang : null;
  const waehlen = async (umfang) => {
    setLaeuft(umfang);
    try { await onWahl(umfang, text.version); } finally { setLaeuft(null); }
  };
  return (
    <div className="space-y-3" data-testid={testId}>
      <p className="text-base font-semibold leading-snug">{text.kurzfrage}</p>
      {!aktiv && (
        <p className="rounded-lg border border-dashed border-border px-3 py-2 text-xs text-muted-foreground" data-testid={`${testId}-gesperrt`}>
          Entwurf, noch nicht freigegeben — die Leitung gibt den Einwilligungstext frei (anwaltlich geprüft), erst dann lässt sich die Frage stellen.
        </p>
      )}
      <div className="grid gap-2 sm:grid-cols-3" role="group" aria-label="Antwort auf die Testimonial-Frage">
        {(text.umfaenge || []).map((u) => (
          <Button key={u.wert} type="button" variant={gewaehlt === u.wert ? 'default' : 'outline'} disabled={!aktiv || !!laeuft}
            aria-pressed={gewaehlt === u.wert} onClick={() => waehlen(u.wert)} data-testid={`${testId}-${u.wert}`}
            className="min-h-11 whitespace-normal text-sm font-semibold">
            {laeuft === u.wert && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />}{u.text}
          </Button>
        ))}
      </div>
      <button type="button" className="text-xs font-medium text-muted-foreground underline underline-offset-2 hover:text-foreground"
        onClick={() => setLang((v) => !v)} aria-expanded={lang}>
        {lang ? 'Einwilligungstext ausblenden' : 'Ganzen Einwilligungstext lesen'}
      </button>
      {lang && (
        <div className="max-h-72 overflow-y-auto rounded-lg bg-muted/50 p-3 text-xs leading-relaxed whitespace-pre-line" data-testid={`${testId}-text`}>
          <p className="mb-1 font-semibold">{text.titel}</p>
          {text.text}
          <p className="mt-2 text-[11px] text-muted-foreground">Fassung {text.version}{text.entwurf ? ' · Entwurf (anwaltlich zu prüfen)' : ''}</p>
        </div>
      )}
    </div>
  );
}
